import React from 'react';
import { useLocation } from 'react-router-dom';

import { TabBlock, TabButton } from '../../nav-bar/secondary-nav-bar.styled';

const TabBar = ({ links, isDisabled }) => {
    const { pathname } = useLocation();

    if (!links.length || isDisabled) {
        return null;
    }

    return (
        <TabBlock>
            {links.map(({ menu, path }, index) => (
                // eslint-disable-next-line react/no-array-index-key -- TODO: legacy index key (baseline)
                <TabButton key={index} to={path} isActive={pathname.includes(path)}>
                    {menu}
                </TabButton>
            ))}
        </TabBlock>
    );
};

export default TabBar;
